// extracted by mini-css-extract-plugin
export var alertIcon = "_qy-0";